<nz-layout class="x-scroll-hide">
  <nz-spin class="graph-spin" [nzSpinning]="isLoading"> </nz-spin>
  <nz-sider
    class="border_radius_box_shadow"
    [nzCollapsedWidth]="menuWidth"
    [(nzCollapsed)]="collapsed"
    nzWidth="23%"
  >
    <div class="container">
      <div class="list y-scroll hide-scrollbar-y hide-scrollbar">
        <div class="menu">
          <div style="margin-left: 10%; margin-top:9%; display: flex; flex-direction: column; align-items: flex-start; margin-bottom: 20px;">
            <i nz-icon nzType="menu" nzTheme="outline" style="font-size: 24px; color: #000000; margin-bottom: 4px;"></i>
            <span style="font-size: 12px; color: #666;">Menú</span>
            </div>
        </div>
        <app-menus [isCollapsed]="collapsed"></app-menus>
      </div>
    </div>
  </nz-sider>

  <nz-layout
    class="content-layout"
    (click)="closeSlider()"
    [ngClass]="{ 'slide-right': !collapsed, 'layout-width': !collapsed }"
  >
    <nz-content [ngClass]="{ 'layout-right': !collapsed }">
      <div class="inner-content">
        <div [@shellRoutes]="animationState">
          <div class="header-content">
            <div class="header-body">
              <div class="header-title-center">
                <img src="assets/icon/icono-sgmm.svg" class="header-icon" alt="icon">
                <span class="header-text">Seguro de Gastos Médicos Menores</span>
              </div>
              
              <div class="header-controls">
                <div class="user-section">
                  <nz-avatar
                    [nzGap]="2"
                    [ngStyle]="{
                      background: '#FFFFFF',
                      border: '2px solid rgba(0, 0, 0, 0.1)',
                      color: '#000000',
                      fontWeight: 'bold'
                    }"
                    [nzText]="getInitials(userAD?.name) || 'U'"
                    nzSize="large"
                    style="vertical-align: middle"
                  ></nz-avatar>
                  
                  <div class="user-info">
                    <span class="user-name">{{ userAD?.name || 'Usuario' }}</span>
                    <span class="user-role">{{ user?.rol || 'Colaborador' }}</span>
                  </div>
                </div>
                
                <!-- Icono de notificaciones -->
                <nz-badge [nzCount]="notificaciones.length" class="notification-badge">
                  <i
                    nz-icon
                    nzType="bell"
                    nzTheme="outline"
                    class="header-icon-btn"
                    nz-dropdown
                    [nzDropdownMenu]="notificationMenu"
                    nzPlacement="bottomRight"
                  ></i>
                </nz-badge>

                <i
                  nz-icon
                  nzType="user"
                  nzTheme="outline"
                  class="header-icon-btn"
                  nz-dropdown
                  [nzDropdownMenu]="headerUserMenu"
                  nzPlacement="bottomRight"
                ></i>
              </div>
            </div>
          </div>
          <div class="padding-left-5">
            <router-outlet (activate)="onActivate()"></router-outlet>
          </div>
        </div>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
<app-pie-de-pagina></app-pie-de-pagina>

<nz-dropdown-menu #userMenu="nzDropdownMenu">
  <ul class="user-menu" nz-menu nzSelectable>
    <li nz-menu-item class="cursor-no-pointer">
      {{ "user?.name" }}
    </li>
    <li
      nz-menu-item
      routerLink="profile"
      routerLinkActive="ant-menu-item-selected"
    >
      <i nz-icon nzType="setting"></i>{{ "shared.shell.label1" }}
    </li>
    <li (click)="logout()" nz-menu-item>
      <i nz-icon nzType="logout"></i>{{ "shared.shell.label2" }}
    </li>
  </ul>
</nz-dropdown-menu>

<nz-dropdown-menu #notificationMenu="nzDropdownMenu">
  <ul nz-menu style="width: 300px">
    <li
      nz-menu-item
      class="cursor-no-pointer"
      style="background: #f5f5f5; font-size: 14px"
    >
      <i nz-icon nzType="bell"></i> Notificaciones
    </li>
    <nz-divider style="margin: 8px 0"></nz-divider>
    <ng-container *ngIf="notificaciones.length === 0; else TemplateNotificaciones">
      <li
        nz-menu-item
        class="cursor-no-pointer"
        style="background: #f5f5f5; text-align: center; font-size: 14px"
      >
        No hay notificaciones
      </li>
    </ng-container>
    <ng-template #TemplateNotificaciones>
    <li
      nz-menu-item
      style="white-space: normal; height: auto; padding: 12px 16px"
      *ngFor="let notificacion of notificaciones"
    >
      <div>
        <div style="font-size: 14px;">{{ notificacion?.mensaje }}</div>
        <div style="font-size: 12px; color: #999; margin-top: 4px">
          {{ notificacion?.fecha }}
        </div>
      </div>
    </li>
    </ng-template>
    <!-- <li
      nz-menu-item
      style="white-space: normal; height: auto; padding: 12px 16px"
    >
      <div>
        <div style="font-weight: 500">Nueva solicitud de reembolso</div>
        <div style="font-size: 12px; color: #999; margin-top: 4px">
          Hace 2 horas
        </div>
      </div>
    </li>
    <li
      nz-menu-item
      style="white-space: normal; height: auto; padding: 12px 16px"
    >
      <div>
        <div style="font-weight: 500">Pago procesado exitosamente</div>
        <div style="font-size: 12px; color: #999; margin-top: 4px">
          Hace 1 día
        </div>
      </div>
    </li>
    <li
      nz-menu-item
      style="white-space: normal; height: auto; padding: 12px 16px"
    >
      <div>
        <div style="font-weight: 500">Recordatorio: Cita médica</div>
        <div style="font-size: 12px; color: #999; margin-top: 4px">
          Hace 3 días
        </div>
      </div>
    </li> -->
    <nz-divider style="margin: 8px 0"></nz-divider>

  </ul>
</nz-dropdown-menu>

<nz-dropdown-menu #headerUserMenu="nzDropdownMenu">
  <ul nz-menu nzSelectable>
    <!-- <li nz-menu-item class="cursor-no-pointer" style="background: #f5f5f5">
      <i nz-icon nzType="user"></i>
      {{ user?.email }}
    </li>
    <nz-divider style="margin: 8px 0"></nz-divider> -->
    <li (click)="logout()" nz-menu-item>
      <i nz-icon nzType="logout"></i> Cerrar Sesión
    </li>
  </ul>
</nz-dropdown-menu>
